import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { generateInventoryInTransitSearchParams } from "../../../../utils"
import { SearchPayload } from "../../../search/SearchPayload"
import { InventorySearchItemsResult } from "../../data/model/inventorySearchItemsResult"

export class InTransitService {
    static async findInTransitBySearchPayload(
        paginatedSearch : Partial<SearchPayload>) : Promise<InventorySearchItemsResult> {
        const postData = generateInventoryInTransitSearchParams(paginatedSearch)
        const res = await AppContext.getApiClient().post("/listing/search", postData)
        if (res.error) {
            throw new Error(res.error.message)
        } 
    
        return res as InventorySearchItemsResult
    }
}



// WEBPACK FOOTER //
// ./src/state/inventory/intransit/service/intransitservice.ts